<div class="card">
  <div class="card-content">

    <!-- Loading state -->
    <div class="portfolio-loading" *ngIf="loading">
      <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem; color: var(--primary-color);"></i>
      <span>Loading presales summary…</span>
    </div>

    <ng-container *ngIf="!loading">

      <!-- ============ KPI cards ============ -->
      <div class="portfolio-kpi-row">
        <div class="stats-card" *ngFor="let card of cards" [ngClass]="card.styleClass">
          <div class="stats-card-main">
            <span class="stats-card-label">{{ card.label }}</span>
            <span class="stats-card-value">{{ card.value }}</span>
            <span class="stats-card-sublabel">{{ card.sublabel }}</span>
          </div>
          <div class="stats-card-icon"><i [class]="'pi ' + card.icon"></i></div>
        </div>
      </div>

      <!-- ============ Charts row ============ -->
      <div class="portfolio-dashboard-grid">
        <section class="portfolio-panel portfolio-panel--charts">
          <article class="chart-card">
            <div class="panel-header"><h3>Projects by Stage</h3></div>
            <div class="chart-shell">
              <p-chart *ngIf="hasStageData; else stageEmpty" type="doughnut" [data]="stageChartData" [options]="chartOptions"></p-chart>
              <ng-template #stageEmpty>
                <div class="chart-empty"><i class="pi pi-chart-pie"></i><span>No presales projects yet</span></div>
              </ng-template>
            </div>
          </article>

          <article class="chart-card">
            <div class="panel-header"><h3>Projects by Presales PM</h3></div>
            <div class="chart-shell">
              <p-chart *ngIf="hasPmData; else pmEmpty" type="doughnut" [data]="pmChartData" [options]="chartOptions"></p-chart>
              <ng-template #pmEmpty>
                <div class="chart-empty"><i class="pi pi-users"></i><span>No assigned PMs</span></div>
              </ng-template>
            </div>
          </article>

          <article class="chart-card">
            <div class="panel-header"><h3>Pipeline by Currency (≈ USD value)</h3></div>
            <div class="chart-shell">
              <p-chart *ngIf="hasCurrencyData; else currencyEmpty" type="doughnut" [data]="currencyChartData" [options]="chartOptions"></p-chart>
              <ng-template #currencyEmpty>
                <div class="chart-empty"><i class="pi pi-wallet"></i><span>No open pipeline</span><small>All deals are Won or Lost</small></div>
              </ng-template>
            </div>
          </article>
        </section>

        <!-- ============ Table ============ -->
        <section class="portfolio-panel portfolio-panel--table portfolio-panel--full-width">

          <div class="table-shell">
            <p-table
              [value]="healthRows"
              [scrollable]="true"
              scrollHeight="400px"
              [paginator]="healthRows.length > 15"
              [alwaysShowPaginator]="false"
              [rows]="15"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} pursuits"
              [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
              styleClass="p-datatable no-column-lines compact-striped-table presales-summary-table table-no-xscroll">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 6%;">Code</th>
                  <th style="width: 14%;">Project</th>
                  <th style="width: 12%;">Client</th>
                  <th style="width: 12%;">Presales PM</th>
                  <th style="width: 13%;">Sales Owner</th>
                  <th style="width: 7%;">Stage</th>
                  <th class="cell-right" style="width: 9%;">Revenue</th>
                  <th class="cell-right" style="width: 6%;">Win %</th>
                  <th style="width: 7%;">Start</th>
                  <th style="width: 7%;">End</th>
                  <th style="width: 7%;">Expected</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr>
                  <td><span class="code-cell">{{ row.code }}</span></td>
                  <td class="row-primary" [pTooltip]="row.name" [tooltipDisabled]="!row.name" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ row.name }}</td>
                  <td [pTooltip]="row.client" [tooltipDisabled]="row.client === '—'" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ row.client }}</td>
                  <td [pTooltip]="row.pm" [tooltipDisabled]="row.pm === '—'" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ row.pm }}</td>
                  <td [pTooltip]="row.accountManager" [tooltipDisabled]="row.accountManager === '—'" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ row.accountManager }}</td>
                  <td><p-tag [value]="row.stage" [severity]="stageSeverity(row.stage)" style="font-size: 0.7rem;" /></td>
                  <td class="money cell-right">
                    <span class="cur">{{ row.currency }}</span> {{ formatMoney(row.revenue) }}
                  </td>
                  <td class="win-pct cell-right" [class.win-high]="row.winning >= 70">{{ row.winning }}%</td>
                  <td>{{ formatDate(row.startDate) }}</td>
                  <td>{{ formatDate(row.endDate) }}</td>
                  <td>{{ formatDate(row.expectedClose) }}</td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr class="table-empty-row">
                  <td colspan="11" class="table-empty-cell">
                    <div class="empty-state">
                      <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                      <p class="empty-message">No active pursuits</p>
                      <p class="empty-description">Add presales projects in Presales → Presales Project Inventory.</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </section>
      </div>

    </ng-container>

  </div>
</div>
